import { useGetDocumentQuery } from 'features/documents/documents';
import { useParams } from 'react-router-dom';

/**
 * @param {string|number} [id]
 * @param {boolean} [showAreas=false]
 * @param {boolean} [refetchOnMountOrArgChange=false]
 * @param {boolean} [returnResults=false]
 *
 * @returns {import('models/documents.models').Document | undefined}
 */
export function useGetDocument(id, showAreas = false, refetchOnMountOrArgChange = false, returnResults = false) {
    const { documentId } = useParams();
    const documentIdForQuery = id ? parseInt(id) : parseInt(documentId);

    const documentQuery = useGetDocumentQuery(
        { id: documentIdForQuery, showAreas },
        {
            selectFromResult: (result) => ({
                ...result,
                document: result.currentData,
            }),
            skip: !documentIdForQuery,
            refetchOnMountOrArgChange,
        },
    );

    if (returnResults) {
        return documentQuery;
    }

    return documentQuery.document;
}
